import React, { Component } from 'react'
import style from './style.css'

class Select extends Component {

    render() {

        const renderOptions = options => {
            if(!options) return false
            return options.map(option => (
                <option key={option.value} value={option.value}>
                    {option.value}
                </option>
            ))
        }
        
        return (
            <label>
                <select
                    className={`
                        ${style.text} 
                        ${style.select} 
                        ${(this.props.transparent) ? style.transparent : ''} 
                        ${(this.props.theme) ? style['theme'+this.props.theme] : ''} 
                        ${this.props.className || ''}
                        `}
                    defaultValue={this.props.defaultValue || undefined}
                    value={this.props.value}
                    placeholder={this.props.placeholder || ''}
                    onChange={(e) => this.props.handleChange(e) || null}
                    name={this.props.name || ''}
                    disabled={this.props.disabled}
                    >
                    {renderOptions(this.props.options) || this.props.children}
                </select>
                <div className={style.arrow} />
            </label>
        )
    }
}

export default Select


// WEBPACK FOOTER //
// ./src/SPRINTA/Topbar/atoms/Forms/select.js